import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export function useCatalog() {
  return useQuery({
    queryKey: ["catalog"],
    queryFn: async () => (await api.get("/catalog")).data,
    staleTime: Infinity,
  });
}
